export default __webpack_public_path__ + "static/gatsby-logo-2dc5c3bd7f6adfe4e1d2882084fde869.jpg";